import { dateUtils } from './DateUtils';
import { DATE_UNAVAILABILITY_REASON } from './availabilityStatus';

const nightsLabel = (n) => {
    if (n === 1) return '1 noc';
    if (n >= 2 && n <= 4) return `${n} noce`;
    return `${n} nocy`;
};

const formatAllowedDays = (daysOfWeek) => {
    if (!Array.isArray(daysOfWeek) || daysOfWeek.length === 0) {
        return null;
    }
    return daysOfWeek
        .map((day) => dateUtils.getLocalizedDayName(day, navigator.language))
        .join(', ');
};

/**
 * Guest-facing Polish tooltip for a restricted availability day (available: false, reason ≠ NO_INVENTORY).
 * Works for both check-in and check-out calendars.
 * @param {import('./availabilityStatus').DateAvailabilityStatus|null|undefined} status
 * @returns {string}
 */
export const getAvailabilityRestrictionTooltip = (status) => {
    if (!status || status.available || status.reason === DATE_UNAVAILABILITY_REASON.NO_INVENTORY) {
        return '';
    }

    switch (status.reason) {
        case DATE_UNAVAILABILITY_REASON.CHECKIN_DAY_NOT_ALLOWED: {
            const days = formatAllowedDays(status.allowedCheckinDaysOfWeek);
            return days
                ? `Zameldowanie możliwe w dni: ${days}`
                : 'Zameldowanie w ten dzień nie jest dozwolone';
        }
        case DATE_UNAVAILABILITY_REASON.MIN_LOS_NOT_MET: {
            if (status.minLos) {
                const base = `Minimalny pobyt: ${nightsLabel(status.minLos)}`;
                return status.multiplyMinLos
                    ? `${base} (mnożnik długości pobytu)`
                    : base;
            }
            return 'Nie spełniono minimalnej długości pobytu';
        }
        case DATE_UNAVAILABILITY_REASON.NO_VALID_STAY: {
            if (status.minLos) {
                return `Brak możliwości zrealizowania pobytu (min. ${nightsLabel(status.minLos)})`;
            }
            return 'Brak możliwości zrealizowania pobytu w tym terminie';
        }
        case DATE_UNAVAILABILITY_REASON.RATE_PLAN_UNAVAILABLE:
            return 'Oferta niedostępna w tym terminie';
        case DATE_UNAVAILABILITY_REASON.CHECKOUT_DAY_NOT_ALLOWED: {
            const days = formatAllowedDays(status.allowedCheckoutDaysOfWeek);
            return days
                ? `Wymeldowanie możliwe w dni: ${days}`
                : 'Brak dozwolonego dnia wymeldowania';
        }
        default:
            return 'Termin niedostępny';
    }
};

export const getCheckinRestrictionTooltip = getAvailabilityRestrictionTooltip;
